// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__woS_I"};